import { Nullable } from 'utils/types';
import { EMPTY_VALUE_PLACEHOLDER } from 'config/variables';

const defaultOptions = {
  preffix: '',
  suffix: '',
  placeholder: EMPTY_VALUE_PLACEHOLDER,
};

const defaultSeparator = ', ';

export const arrayPlaceholder = (
  array: any[],
  fieldname?: Nullable<string | number>,
  options?: Partial<typeof defaultOptions>,
  joinString?: string
): string => {
  const separator = joinString ?? defaultSeparator;
  const { placeholder, preffix, suffix } = {
    ...defaultOptions,
    ...options,
  };
  if (array.length > 0) {
    return array
      .map((obj) => {
        if (typeof obj === 'string' || typeof obj === 'number') {
          return `${preffix}${obj}${suffix}`;
        }
        if (fieldname && obj?.hasOwnProperty(fieldname)) {
          return `${preffix}${obj[fieldname]}${suffix}`;
        }
        return '';
      })
      .join(separator);
  }
  return placeholder;
};
